import styled from 'styled-components'

export const Container = styled.div`
  padding-block: 32px;
  width: 100%;

  @media (min-width: 912px) {
    padding-inline: 62px;
  }

  @media (max-width: 568px) {
    padding-block: 0;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-inline: auto;
  max-width: 1366px;
  width: 100%;

  & > h1 {
    color: #013C1A;
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
    padding-inline: 24px;
    max-width: 640px;
  }

  & > button {
    max-width: 310px;
    width: 100%;
  }

  & > .swiper {
    width: 100%;

    & > .container > .cards {
      gap: 32px;

      .large {
        p {
          font-size: 1.5rem;
          font-weight: 700;
          text-align: center;
        }
      }

      .small {
        p {
          font-size: 1rem;
          font-weight: 400;
          line-height: 120%;
          letter-spacing: 0%;
          text-align: center;
        }
      }
    }
  }

  @media (max-width: 568px) {
    gap: 38px;

    & > h1 {
      font-size: 24px;
    }

    & > .swiper {
      & > .container > .cards {
        gap: 16px;

        .large {
        p {
          font-size: 1.25rem;
        }
      }

      .small {
        p {
          font-size: 0.875rem;
        }
      }
      }
    }

    & > button {
      border: 1px solid red;
      margin-inline: 24px;
    }
  }
`
